module.exports = "/assets/eeaa48b345cbd717d854750224b21073.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZI.png
// module id = 2065
// module chunks = 0